const signals = require('../../../../../signals/account/orders');
const { Checkbox } = require('../../../../../packages/account-ui');
const { cut } = require('../../../../../helpers/utils');
const css = require('./documents.css');

const LOAD_FILE_BUTTON_SELECTOR = cut(css.fileUploadInput);
const DELETE_DOCUMENT_BUTTON_SELECTOR = cut(css.deleteDocumentButton);
const DOWNLOAD_FILE_LINK_SELECTOR = cut(css.downloadFileLink);
const DOWNLOAD_DRAFT_SELECTOR = cut(css.downloadDraftLink);

class Documents {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [DELETE_DOCUMENT_BUTTON_SELECTOR]: this.deleteDocument,
                [DOWNLOAD_FILE_LINK_SELECTOR]: this.downloadFile,
                [DOWNLOAD_DRAFT_SELECTOR]: this.downloadDraftFile
            },
            change: {
                [LOAD_FILE_BUTTON_SELECTOR]: this.uploadDocument
            }
        };
    }

    uploadDocument (e) {
        const documentTypeId = Number(e.target.attributes['cat-documentTypeId'].value);
        const file = e.target.files[0];

        this.$context.signal(signals.uploadDocument, { documentTypeId, file });
    }

    deleteDocument (e) {
        const documentId = e.target.attributes['cat-documentId'].value;

        this.$context.signal(signals.deleteDocument, { documentId });
    }

    downloadFile (e) {
        const fileId = Number(e.target.attributes['cat-id'].value);

        this.$context.signal(signals.downloadFile, { fileId });
    }

    downloadDraftFile (e) {
        const typeId = Number(e.target.attributes['cat-type-id'].value);
        const orderId = e.target.attributes['cat-order-id'].value;

        this.$context.signal(signals.downloadDraftFile, { orderId, typeId });
    }
}

module.exports = {
    constructor: Documents,
    children: [
        {
            name: 'checkbox',
            component: Checkbox,
            props: {
                signal: signals.setDocumentType
            },
            watcher: (attributes) => ({
                value: ['account', 'orders', 'currentOrder', 'necessaryDocuments',
                    Number(attributes['cat-path']), 'isChecked']
            })
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/documents/index.js